<div class="cerrix-page-footer">
    <ng-content></ng-content>
</div>
